import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { PrimeReactProvider } from "primereact/api";
import { PersistGate } from 'redux-persist/integration/react';
import PropTypes from 'prop-types';
import { BrowserRouter } from 'react-router-dom'; // Replace ConnectedRouter
import { Provider } from 'react-redux';
import { createBrowserHistory } from "history";
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const clickPluginInstance = new ClickAnalyticsPlugin();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // Disables retries - using ky's built-in retry logic instead
    },
  },
});

// Initialize Application Insights if in production
// eslint-disable-next-line no-undef
if (__DEV__ === false) {
	// eslint-disable-next-line no-undef
	const aiConnString = __APP_INSIGHTS_CONN_STRING__;

	if (aiConnString) {
		const clickPluginConfig = {
			autoCapture: true,
			dataTags: { useDefaultContentNameOrId: true },
		};

		const appInsights = new ApplicationInsights({
			config: {
				connectionString: aiConnString,
				extensions: [reactPlugin, clickPluginInstance],
				extensionConfig: {
					[reactPlugin.identifier]: { history: browserHistory },
					[clickPluginInstance.identifier]: clickPluginConfig,
				},
			},
		});
		appInsights.loadAppInsights();
	}
}

class Root extends React.Component {
  render() {
    const { store, persistor } = this.props; // Remove history since it's no longer needed
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <PrimeReactProvider>
				<QueryClientProvider client={queryClient}>
					<App />
				</QueryClientProvider>
			</PrimeReactProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  persistor: PropTypes.object.isRequired
};

export default withAITracking(reactPlugin, Root);
